import React from 'react'
import { Box, Button, } from 'grommet'
import { FiMenu, FiX } from 'react-icons/fi'
import MenuContent from "./MenuContent";

class Menu extends React.Component {
  
    constructor(props, context) {
        super(props, context);
        this.state = {
            visible: false,
        };
        this.handleMouseDown = this.handleMouseDown.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.bgcolor = 'yellow'
        this.IconClose = (<FiX color='text' size='2em'/>)
        this.IconMenu = (<FiMenu color='text' size='2em'/>)
        this.icons = {'open': this.IconMenu, 'close': this.IconClose}
        this.icon = 'open'
    }

    handleMouseDown(e) {
        this.toggleMenu();
        e.stopPropagation();
    }

    toggleMenu() {
      if (this.state.visible) { this.setState({visible: false})}
      else { this.setState({visible: true})}
      this.icon = (this.icon == 'open') ? 'close' : 'open';
      this.bgcolor="red"
    }


  render() {
    return (
      <Box align='start' style={{position: 'absolute'}}>
        <Box style={{position: 'absolute', zIndex: '999'}}>
          <Button
            icon={this.icons[this.icon]} //{<FiMenu color='text' size='2em'/>}
            onClick={this.handleMouseDown}
          />
        </Box>
        <MenuContent
          menuVisibility={this.state.visible}
        />
      </Box>
    )
  }
}

export default Menu